var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"relative",attrs:{"bordered":false}},[_c('page-back-btn'),_c('a-tabs',{attrs:{"type":"card","defaultActiveKey":_vm.activeKey},on:{"change":_vm.changeTab}},_vm._l((_vm.tabs),function(item){return _c('a-tab-pane',{key:item.key,attrs:{"tab":item.title}},[_c(item.component,{tag:"component"})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }